class WithdrawalForm extends HTMLElement {
  connectedCallback() {
    this.listId = this.dataset.klaviyoListId;
    this.successText = this.dataset.successText;
    this.errorText = this.dataset.errorText;
    this.apiUrl = "https://feno-co-tjjv.vercel.app/api/withdraw";

    this.step1 = this.querySelector(".step-1");
    this.step2 = this.querySelector(".step-2");
    this.form = this.querySelector("#withdrawal-step-1");
    this.errorEl = this.querySelector(".wf-error");
    this.successEl = this.querySelector(".wf-success");
    this.selectError = this.querySelector(".wf-select-error");

    this.btnText = this.querySelector(".wf-btn-text");
    this.btnSpin = this.querySelector(".wf-btn-spin");
    this.confirmText = this.querySelector(".wf-confirm-text");
    this.confirmSpin = this.querySelector(".wf-confirm-spin");
    this.backBtn = this.querySelector(".wf-back-btn");
    this.confirmBtn = this.querySelector(".wf-confirm-btn");

    this.reviewOrder = this.querySelector("#wf-review-order");
    this.itemsList = this.querySelector("#wf-items-list");
    this.selectAll = this.querySelector("#wf-select-all");

    this.step1Indicator = this.querySelector(".wf-step-1-indicator");
    this.step2Indicator = this.querySelector(".wf-step-2-indicator");

    this.formData = {};
    this.orderItems = [];

    this.form.addEventListener("submit", this.handleVerify.bind(this));
    this.backBtn.addEventListener("click", this.goBack.bind(this));
    this.confirmBtn.addEventListener("click", this.handleConfirm.bind(this));
    this.selectAll.addEventListener("change", this.handleSelectAll.bind(this));
  }

  setActiveStep(step) {
    if (step === 1) {
      this.step1Indicator.classList.remove("opacity-40");
      this.step1Indicator.querySelector(".wf-step-num").classList.remove("bg-opacity-10");
      this.step1Indicator.querySelector(".wf-step-num").classList.add("bg-black", "text-white");
      this.step2Indicator.classList.add("opacity-40");
      this.step2Indicator.querySelector(".wf-step-num").classList.add("bg-opacity-10");
      this.step2Indicator.querySelector(".wf-step-num").classList.remove("text-white");
    } else {
      this.step1Indicator.classList.add("opacity-40");
      this.step2Indicator.classList.remove("opacity-40");
      this.step2Indicator.querySelector(".wf-step-num").classList.remove("bg-opacity-10");
      this.step2Indicator.querySelector(".wf-step-num").classList.add("bg-black", "text-white");
    }
  }

  async handleVerify(e) {
    e.preventDefault();
    var fd = new FormData(this.form);
    this.formData = {
      email: (fd.get("email") || "").toString().trim(),
      orderNumber: (fd.get("orderNumber") || "").toString().trim().replace(/^#/, ""),
    };

    if (!this.formData.email || !this.formData.orderNumber) return;

    this.setBusy(this.form.querySelector('[type="submit"]'), this.btnText, this.btnSpin, true);
    this.hideMessages();

    try {
      var resp = await fetch(this.apiUrl, {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({
          action: "verify",
          email: this.formData.email,
          orderNumber: this.formData.orderNumber,
        }),
      });

      var data = await resp.json();

      if (!resp.ok || data.error) {
        throw new Error(data.error || "Request failed");
      }

      this.orderItems = data.items || [];
      this.reviewOrder.textContent = data.orderName || "#" + this.formData.orderNumber;
      this.renderItems();
      this.step1.classList.add("hidden");
      this.step2.classList.remove("hidden");
      this.setActiveStep(2);
    } catch (err) {
      var message = err.message && err.message !== "Request failed"
        ? err.message
        : this.errorText;
      this.showError(message);
    } finally {
      this.setBusy(this.form.querySelector('[type="submit"]'), this.btnText, this.btnSpin, false);
    }
  }

  renderItems() {
    this.itemsList.innerHTML = "";
    this.selectAll.checked = false;

    this.orderItems.forEach(function (item, index) {
      var label = item.title;
      if (item.variantTitle && item.variantTitle !== "Default Title") {
        label += " — " + item.variantTitle;
      }

      var row = document.createElement("label");
      row.className = "flex items-center gap-3 cursor-pointer";
      row.innerHTML =
        '<input type="checkbox" name="wf-item" value="' + index + '" class="accent-black w-4 h-4 wf-item-checkbox">' +
        '<div class="flex flex-col">' +
          '<span class="text-sm">' + this.escapeHtml(label) + '</span>' +
          '<span class="text-xs opacity-50">Qty: ' + item.quantity + '</span>' +
        '</div>';

      var checkbox = row.querySelector("input");
      checkbox.addEventListener("change", this.handleItemCheck.bind(this));

      this.itemsList.appendChild(row);
    }.bind(this));
  }

  escapeHtml(str) {
    var div = document.createElement("div");
    div.textContent = str;
    return div.innerHTML;
  }

  handleSelectAll() {
    var checked = this.selectAll.checked;
    var checkboxes = this.itemsList.querySelectorAll(".wf-item-checkbox");
    checkboxes.forEach(function (cb) {
      cb.checked = checked;
    });
    if (this.selectError) this.selectError.classList.add("hidden");
  }

  handleItemCheck() {
    var checkboxes = this.itemsList.querySelectorAll(".wf-item-checkbox");
    var allChecked = true;
    checkboxes.forEach(function (cb) {
      if (!cb.checked) allChecked = false;
    });
    this.selectAll.checked = allChecked;
    if (this.selectError) this.selectError.classList.add("hidden");
  }

  getSelectedItems() {
    var selected = [];
    var checkboxes = this.itemsList.querySelectorAll(".wf-item-checkbox");
    var self = this;
    checkboxes.forEach(function (cb) {
      if (cb.checked) {
        var item = self.orderItems[parseInt(cb.value)];
        var label = item.title;
        if (item.variantTitle && item.variantTitle !== "Default Title") {
          label += " (" + item.variantTitle + ")";
        }
        label += " x" + item.quantity;
        selected.push(label);
      }
    });
    return selected;
  }

  goBack() {
    this.step2.classList.add("hidden");
    this.step1.classList.remove("hidden");
    this.setActiveStep(1);
    this.hideMessages();
  }

  async handleConfirm() {
    var selectedItems = this.getSelectedItems();
    if (selectedItems.length === 0) {
      if (this.selectError) this.selectError.classList.remove("hidden");
      return;
    }

    this.setBusy(this.confirmBtn, this.confirmText, this.confirmSpin, true);
    this.hideMessages();
    if (this.selectError) this.selectError.classList.add("hidden");

    try {
      var resp = await fetch(this.apiUrl, {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({
          action: "submit",
          email: this.formData.email,
          orderNumber: this.formData.orderNumber,
          selectedItems: selectedItems,
          listId: this.listId,
        }),
      });

      var data = await resp.json();

      if (!resp.ok || data.error) {
        throw new Error(data.error || "Request failed");
      }

      this.step2.classList.add("hidden");
      this.querySelector(".wf-steps").classList.add("hidden");
      this.showSuccess(this.successText);
      this.form.reset();
    } catch (err) {
      var message = err.message && err.message !== "Request failed"
        ? err.message
        : this.errorText;
      this.showError(message);
    } finally {
      this.setBusy(this.confirmBtn, this.confirmText, this.confirmSpin, false);
    }
  }

  setBusy(btn, textEl, spinEl, busy) {
    if (btn) btn.disabled = busy;
    if (textEl) textEl.classList.toggle("hidden", busy);
    if (spinEl) spinEl.classList.toggle("hidden", !busy);
  }

  showError(msg) {
    if (this.successEl) this.successEl.classList.add("hidden");
    if (this.errorEl) {
      this.errorEl.textContent = msg;
      this.errorEl.classList.remove("hidden");
    }
  }

  showSuccess(msg) {
    if (this.errorEl) this.errorEl.classList.add("hidden");
    if (this.successEl) {
      this.successEl.textContent = msg;
      this.successEl.classList.remove("hidden");
    }
  }

  hideMessages() {
    if (this.errorEl) this.errorEl.classList.add("hidden");
    if (this.successEl) this.successEl.classList.add("hidden");
  }
}

customElements.define("withdrawal-form", WithdrawalForm);
